import { jsx } from "react/jsx-runtime";
import React from "react";
import { Spinner } from "@blueprintjs/core";
export default function AsyncValidateFieldSpinner({ validating }) {
  if (validating) {
    return /* @__PURE__ */ jsx(Spinner, { size: "18" });
  } else {
    return null;
  }
}
